import React, { Component } from "react"
import "./RuleItem.scss"
import RuleVote from "./RuleVote";

class RuleItem extends Component {
    constructor() {
        super();
        this.state = {}
    }
    render() {
        const _FrontImage = {
            backgroundImage: `url(./static/images/rules/${this.props.ID}.jpg)`
        }
        return (
            <div className="rule-item" style={_FrontImage}>
                <div className="headline">
                    <div className="text" dangerouslySetInnerHTML={{ __html: this.props.name }}></div>
                </div>
                <RuleVote index={this.props.index} votesData={this.props.votesData} nextSlide={this.props.nextSlide} ID={this.props.ID} name={this.props.name} />
            </div>
        )
    }
}

export default RuleItem;


// WEBPACK FOOTER //
// ./src/Components/Rules/RuleItem.jsx